module.exports = __webpack_public_path__ + "static/media/ProjectActive.db619cb4.png";